const Nav = () => {

    const querySelectors = {
        toggleNavEl: document.getElementById('toggle-nav'),
        logo: document.querySelector('.site-logo'),
        menuFill: document.querySelector('.menu.fill'),
        menuItems: document.querySelectorAll('#menu-main-nav.menu > li'),
    }

    const toggleNav = (e) => {
        e.preventDefault();

        const hamburger = querySelectors.toggleNavEl;
        const isMenuOpened = hamburger.classList.contains('active');

        const delay = isMenuOpened ? 900 : 0;

        hamburger.classList.toggle('active');
        querySelectors.logo.classList.toggle('menu-active');

        querySelectors.menuFill.style.display = 'flex';

        setTimeout(() => {
            if (isMenuOpened) {
                querySelectors.menuFill.style.opacity = 0;
                querySelectors.menuFill.style.display = 'none';
            } else {
                querySelectors.menuFill.style.opacity = 1;
                querySelectors.menuFill.style.display = 'flex';
            }
        }, delay);

        querySelectors.menuItems.forEach((menuItem, index) => {
            if (!isMenuOpened) {
                menuItem.style.transform = 'translateY(40px)';
            }

            setTimeout(() => {
                if (isMenuOpened) {
                    menuItem.style.opacity = 0;
                    menuItem.style.transform = 'translateY(-40px)';
                } else {
                    menuItem.style.opacity = 1;
                    menuItem.style.transform = 'translateY(0)';
                }
            }, (index + 1) * 150)
        });
    }

    const changeLogoColor = (e) => {
        if (!querySelectors.logo || !querySelectors.toggleNavEl) return;

        querySelectors.logo.classList.remove('dark');
        querySelectors.toggleNavEl.classList.remove('dark');

        const logoClientRect = querySelectors.logo.getBoundingClientRect();

        const blocks = document.elementsFromPoint(logoClientRect.x, logoClientRect.y).filter(el => {
            return el.classList.contains('fitxr-block--white-color') || el.classList.contains('fitxr-block--light') || el.classList.contains('fitxr-block--pearl-color')
        });

        if (!blocks.length) return;

        querySelectors.logo.classList.add('dark');
        querySelectors.toggleNavEl.classList.add('dark');
    }

    const setupListeners = () => {
        querySelectors.toggleNavEl.addEventListener('click', toggleNav);

        changeLogoColor();

        window.addEventListener('scroll', changeLogoColor, { passive: true })
    }

    return {
        init: () => {
            setupListeners();
        },
    }
}

export default Nav().init
